import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";
import { useHolidaySchedule } from "../../../contexts/HolidayScheduleContext";
import { HolidaySchedule } from "../../../models/HolidaySchedule";

interface Props {
  holidaySchedule: HolidaySchedule;
  children?: React.ReactNode;
}

const HolidayScheduleLiveButton: React.FC<Props> = ({
  holidaySchedule,
  children,
}) => {
  const { updateHolidaySchedule } = useHolidaySchedule();
  const [isOpen, setIsOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    setIsSaving(true);
    try {
      await updateHolidaySchedule(holidaySchedule._id, {
        status: "live",
      });
      setIsOpen(false);
    } catch (error) {
      console.error("Error deleting holidaySchedule:", error);
      alert("Failed to delete holidaySchedule. Please try again later.");
    } finally {
      setIsSaving(false);
    }
  };

  if (!holidaySchedule) return null;
  if (holidaySchedule.status === "live") return null;
  return (
    <>
      <Button type="button" color="green" onClick={() => setIsOpen(true)}>
        {children || "Set Live"}
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Delete Holiday Schedule</AlertTitle>
        <AlertDescription>
          Are you sure you want to set this holiday schedule live?
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={() => setIsOpen(false)} disabled={isSaving}>
            Cancel
          </Button>
          <Button color="green" onClick={handleSubmit} disabled={isSaving}>
            Set Live
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default HolidayScheduleLiveButton;
